import React from 'react';
import type { Integration } from '../../lib/integration-types';

const PROVIDER_INFO: Record<string, { name: string; icon: string }> = {
  slack: { name: 'Slack', icon: '💬' },
  notion: { name: 'Notion', icon: '📝' },
  github: { name: 'GitHub', icon: '🐙' },
  hubspot: { name: 'HubSpot', icon: '🔶' },
  google_workspace: { name: 'Google Workspace', icon: '📁' },
};

interface Props {
  integration: Integration;
  onDisconnect?: () => void;
  onDelete?: () => void;
}

export function IntegrationCard({ integration, onDisconnect, onDelete }: Props) {
  const info = PROVIDER_INFO[integration.provider] || { name: integration.provider, icon: '🔌' };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex items-center gap-3 mb-3">
        <span className="text-2xl">{info.icon}</span>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900">{integration.name}</h3>
          <p className="text-sm text-gray-500">{info.name}</p>
        </div>
        <span className={`px-2 py-0.5 text-xs rounded ${
          integration.status === 'connected' ? 'bg-green-100 text-green-700' :
          integration.status === 'error' ? 'bg-red-100 text-red-700' :
          'bg-gray-100 text-gray-700'
        }`}>
          {integration.status}
        </span>
      </div>

      {integration.status === 'connected' && integration.credentials?.expiresAt && (
        <p className="text-xs text-gray-500 mb-3">
          Expires: {new Date(integration.credentials.expiresAt).toLocaleDateString()}
        </p>
      )}

      <div className="flex gap-2">
        {onDisconnect && integration.status === 'connected' && (
          <button
            onClick={onDisconnect}
            className="text-sm text-gray-600 hover:text-gray-800"
          >
            Disconnect
          </button>
        )}
        {onDelete && (
          <button
            onClick={onDelete}
            className="text-sm text-red-600 hover:text-red-800"
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
}
